<template>
  <div class="welcome-main">
    <div class="wel-ab">
      <!-- web  -->
      <div class="hidden-sm-and-down wel-content wel-web">
        <el-carousel :interval="5000"  height="70vh"  arrow="always">
          <el-carousel-item v-for="(item,index) in $store.state.princess" :key="index" class="card-item">
            <el-image :src="'https://api2.seattletaotao.com'+item.url"
                    :alt="hideMsg"
                    class="wel-img"  width="100%" height="100%">

            </el-image>
            <div class="card-item-child" @click="handleClickFun(index)" >
              <div class="age">胸围 {{item.cir}}</div>
              <div class="Nheight">身高 {{item.stature}}</div>
              <div class="card-item-desc">{{item.info}}</div>

              <div class="ranking"></div>
              <div class="ranking-span">{{index+1}}</div>
              <span class="hide">{{ hideMsg }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- wap   -->
      <div class="hidden-sm-and-up wel-content">
        <el-carousel :interval="5000" height="50vh" :indicator-position="none" arrow="always">
          <el-carousel-item v-for="(item,index) in $store.state.princess" :key="index" class="card-item">
            <img :src="'https://api2.seattletaotao.com'+item.url" alt="" class="wel-img" width="100%" height="100%">
            <div class="card-item-child" @click="handleClickFun(index)" >
              <div class="age">胸围 {{item.cir}}</div>
              <div class="Nheight">身高 {{item.stature}}</div>
              <div class="card-item-desc">{{item.info}}</div>

              <div class="ranking"></div>
              <div class="ranking-span">{{index+1}}</div>
              <span class="hide">{{ hideMsg }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>

      <div class="wel-button">
        <div class="wel-radius">
          <svg class="svg absolute" viewBox="0 0 100 100" width="100" height="100"  @click="$router.push('/welcome')">
            <defs>
              <path id="circle"
                    d="
                    M 50, 50
                    m -37, 0
                    a 37,37 0 1,1 74,0
                    a 37,37 0 1,1 -74,0"
                    style="fill:white;stroke:red;"/>
              <path id="circle2"
                    d="
                    M 25, 68
                    h 80,80
                    m 37, 0"
                    style="stroke:red;stroke-width:2"/>
            </defs>
            <text font-size="10"  fill="#fff">
              <textPath xlink:href="#circle" class="text-black versailles">
                西雅图桃桃私人高级会所     &nbsp &nbsp  电话：425-999-6494
              </textPath>
            </text>
            <text font-size="50" fill="#fff"  >
              <textPath xlink:href="#circle2"> 西</textPath>
            </text>

          </svg>

        </div>

        <!--  content  -->
        <div class="wel-info">
          <p>西雅图私人会所-西雅图桃桃私人会所</p>
          <h1 class="wel-enter" @click="$router.push('/welcome')">Enter</h1>
          <div class="wel-span" @click="$router.push('/welcome')"> <span >已满21周岁进</span></div>
          <div class="wel-info-centent">
            私家高 <br>
            配用 高端订制 由西雅图桃桃私人会所安排车模 <br>
            小明星，网红，洋妞，留学生兼职，当红AV女优 <br>
            <span class="hide">{{ hideMsg }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      msg: 'index',
      hideMsg:'西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所'
    }
  },
  methods: {
    handleClickFun (index) {
      console.log(index);
      let k = Number(index)+1
      let s = k.toString()
      this.crrentIndex = k
      this.$router.push({path:'/princess',query: {id:s}})
    }
  },
}
</script>

<style scoped type="text/scss">
.welcome-main{
  position: relative;
  z-index: 3000;
}
.wel-ab{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: #4b5a68;
  overflow-y: scroll;
}
/*wel-content*/
.wel-content{color: #ffffff;}
.el-carousel__item:nth-child(2n) {background-color: #99a9bf;}
.el-carousel__item:nth-child(2n+1) {background-color: #d3dce6;}

/*---------------------------------*/
.wel-img{position: absolute; top: 0;left: 0; }
.card-item{ background-color: white;}
.card-item-child{position: relative;}
.Nheight,.age{position: absolute; padding: 2px 6px;background-color: #f787c9;border-radius: 8px; opacity: 0.8; color: white;font-size: 14px;}
.Nheight{ top: 80px;right: 5%;}
.age{top: 50px;right: 5%; background-color: #00c7ff; }
.card-item-desc{
  position: relative;
  top:30vh;
  cursor: pointer;
  text-align: left;
  text-indent: 1.5rem;
  width: 96vw;
  padding: 2vw;
  -webkit-box-orient: vertical;background-color: #f787c9;opacity: .9;  }
.price-list span{ margin: 2px 15px; padding:3px 0px;border-radius: 6px;background-color:#f787c9;color: white; }
.hide{display: none;}
.ranking{
  border-top: 50px solid #dc143c;
  margin-left: 0;
  width: 0;
  height: 0;
  border-right: 50px solid transparent;
  position: absolute;top: 0;left: 0;
  z-index: 2;
}
.ranking-span{position: absolute;top: 5px;left: 10px; z-index: 3;color: white;}

.wel-button{height: 46vh; position: relative;}
.wel-radius{height: 100px;width: 100px; border-radius: 50px; background-color: orange; position: absolute; top: -50px; z-index: 3003;   font-size: 3rem;line-height:100px;}
.versailles{color: #ffffff;}

.wel-web{width: 1200px;margin: auto;}
.wel-info{padding-top: 60px;color: white;}
.wel-span{margin-top: 1rem;margin-bottom: 1.5rem;}
.wel-span span{padding: 6px 2rem;background-color: coral;border-radius: 10px;}
.wel-info-centent{border-radius: 10px; border: white solid 2px;width: 90vw;margin: auto; padding: 2vw;}
.wel-enter,.wel-span,.wel-span span{cursor: pointer; }


@media only screen and (max-width:767px){
  .wel-radius{left: 40vw;}
}
@media only screen and (min-width:768px){
  .wel-radius{left: 47vw;}
}
</style>



// WEBPACK FOOTER //
// src/page/welcome.vue